import http, { download } from '@/utils/request'
export const getV6InvestintentListPage = params => {
  return http({
    url: 'dealermanage/v6investintent/listpage',
    params
  })
}
export const getV6InvestintentDetail = id => {
  return http({
    url: `dealermanage/v6investintent/detail/${id}`
  })
}
export const addV6Investintent = data => {
  return http({
    url: 'dealermanage/v6investintent/add',
    method: 'POST',
    data
  })
}
export const updateV6Investintent = data => {
  return http({
    url: 'dealermanage/v6investintent/update',
    method: 'POST',
    data
  })
}
export const deleteV6Investintent = data => {
  return http({
    url: 'dealermanage/v6investintent/delete',
    method: 'POST',
    data
  })
}
export const downloadV6InvestintentTemplate = () => {
  return download('dealermanage/v6investintent/downloadTemplate')
}
export const uploadV6InvestintentTemplate = data => {
  return http({
    url: 'dealermanage/v6investintent/import',
    method: 'POST',
    data
  })
}
export const exportV6Investintent = data => {
  return http({
    url: 'dealermanage/v6investintent/export',
    method: 'POST',
    data
  })
}
